export default "__VITE_ASSET__BXL6CA_3__"